import Fetch from '../Fetch';

export default {
  queryConfiguration: (params, config = { loading: true }) => {
    const {loading} = config
    return Fetch.get(`/api/v1/swcfg_ports_status`, { params, loading: loading });
  },

  settingConfiguration: (params, config = { loading: true }) => {
    const {loading} = config
    return Fetch.post(`/api/v1/swcfg_ports_ex`, params, {loading: loading});
  },

  queryConfigurationList: (params, config = {}) => {
    return Fetch.get(`/api/v1/swcfg_ports_status`, { params, ...config });
  }
};
